import { GAtracker } from './ga.service.js';

export const TrackEvent = {
  record
};

function record(event, attr, value, componentId = '') {
  // record here
  GAtracker.record(event, attr + ': ' + value);

  if (window.location.hostname === 'localhost') {
    console.log('Event: '+event+'\nAttribute: '+attr+'\nValue: '+value+'\nComponent Id: '+componentId);
  }
}

export const EVENTS = {
  Click: 'Click',
  Game: 'Game',
  Hover: 'Hover',
  Video: 'Video'
};

export const EVENT_ATTRIBUTES = {
  Click: {
    Actions: 'Actions',
    Clickthru: 'Clickthru',
    URL: 'URL'
  },
  Game: {
    Started: 'Started',
    Completed: 'Completed',
    Muted: 'Muted',
    Unmuted: 'Unmuted',
    Replay: 'Replay',
    Actions: 'Actions'
  },
  Hover: {
    Hover: 'Hover',
    Actions: 'Actions'
  },
  Video: {
    Start: 'Start',
    Pause: 'Pause',
    VP_25: 'VP_25',
    VP_50: 'VP_50',
    VP_75: 'VP_75',
    Finish: 'Finish',
    Hover: 'Hover',
    Mute: 'Mute',
    Unmute: 'Unmute',
    Fullscreen: 'Fullscreen',
    Resume: 'Resume',
    Seek: 'Seek',
    Click: 'Click'
  }
};
